import * as yup from 'yup';

export const CreateLateFeeConfigFormValidation = yup.object().shape({
    idPaymentType: yup.string().required('Tipo pagamento é obrigatória'),
    feeAmount: yup.number().typeError("Deve ser numero").required('Valor de atraso obrigatória'),
    feePercentage: yup.number().typeError("Deve ser numero").required('Percentual é obrigatória'),
    daysAfterDueDate: yup.number().typeError("Deve ser numero").required('Periodo de acrescimo é obrigatório').default(5),
    startDay: yup.number().typeError("Deve ser numero").required('Periodo de acrescimo é obrigatório'),
    endDay: yup.number().typeError("Deve ser numero").required('Periodo de acrescimo é obrigatório'),

});